import React, { FC, useCallback } from 'react';
import classnames from 'classnames';

import IconCustom from 'components/common/IconCustom';
import GatsbyImage from 'components/common/GatsbyImage';
import DangerouslySetInnerHtml from 'gatsby-theme-gaviscon/src/components/common/DangerouslySetInnerHtml';
import { DiscoveryBlockProps } from './model';
import './DiscoveryBlock.scss';

const DiscoveryBlock: FC<DiscoveryBlockProps> = ({
  description,
  title,
  image,
  imageAlt,
  sectionTheme,
  isActive = false,
  changeImage = false,
  itemIndex,
  imageSwitchHandler,
}) => {
  const handleClick = useCallback(() => {
    if (imageSwitchHandler) {
      imageSwitchHandler(itemIndex);
    }
  }, [imageSwitchHandler, itemIndex]);

  return (
    <div
      className={classnames('gs-discovery-block', {
        'active-paragraph': isActive,
        [`gs-discovery-block--${sectionTheme}`]: sectionTheme,
      })}
      data-testid="discovery-block"
    >
      {image?.fallbackUrl ? (
        <GatsbyImage className="gs-discovery-block__image" fluid={image} alt={imageAlt} />
      ) : null}

      {changeImage ? (
        <button
          onClick={handleClick}
          className="gs-discovery-block__title"
          aria-label={title}
          type="button"
        >
          <DangerouslySetInnerHtml html={title} />
        </button>
      ) : (
        <strong className="gs-discovery-block__title">
          <IconCustom icon="tick" />
          <DangerouslySetInnerHtml html={title} />
        </strong>
      )}

      <DangerouslySetInnerHtml className="gs-discovery-block__description" html={description} />
    </div>
  );
};

export default DiscoveryBlock;
